// @ts-nocheck
import { get, put, post, deleteRequest } from './utils/api/index';
const API_URL = (process.env.REACT_APP_BASE_API_URL_SYNC || 'http://localhost:32768').trim();
const DESCARGA_CONTROLE_URL = new URL('/api/v1/descarga/controle', API_URL).toString();
const DESCARGA_CONTROLE_AUDITORIAS_URL = `${DESCARGA_CONTROLE_URL}/auditorias`;
const DESCARGA_CONTROLE_RELATORIO_EXCEL_URL = `${DESCARGA_CONTROLE_URL}/relatorio/excel`;
const DESCARGA_CONTROLE_RELATORIO_PDF_URL = `${DESCARGA_CONTROLE_URL}/relatorio/pdf`;
const DESCARGA_CONTROLE_MANUAL_URL = `${DESCARGA_CONTROLE_URL}/manual`;
const DESCARGA_CONTROLE_METRICAS_URL = `${DESCARGA_CONTROLE_URL}/metricas`;
const JANELAS_URL = new URL('/api/v1/descarga/janelas', API_URL).toString();
const buildControleDescargaRegistroUrl = ({ pedCodigo, cliCodigo, carCodigo }) => `${DESCARGA_CONTROLE_URL}/registros/${encodeURIComponent(String(pedCodigo))}/${encodeURIComponent(String(cliCodigo))}/${encodeURIComponent(String(carCodigo))}`;
const buildQueryString = (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item !== undefined && item !== null && item !== '') {
                    queryParams.append(key, String(item));
                }
            });
            return;
        }
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    return queryParams.toString();
};
export const getControleDescargas = async (filters = {}) => {
    const query = buildQueryString(filters);
    const url = query ? `${DESCARGA_CONTROLE_URL}?${query}` : DESCARGA_CONTROLE_URL;
    const response = await get(url, {
        headers: {
            Accept: 'application/json'
        }
    });
    return (response?.data || response || {
        registros: [],
        totalRegistros: 0,
        paginaAtual: Number(filters.PaginaAtual) || 1,
        quantidadePorPagina: Number(filters.QuantidadePorPagina) || 50
    });
};
export const updateControleDescargaRegistro = async (key, payload) => {
    const response = await put(buildControleDescargaRegistroUrl(key), payload, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json'
        }
    });
    return response?.data || response;
};
export const updateControleDescargaRegistroAtivo = async (key, ativo, payload = {}) => {
    const response = await put(buildControleDescargaRegistroUrl(key), {
        ...payload,
        ativo
    }, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json-patch+json'
        }
    });
    return response?.data || response;
};
export const deleteControleDescargaRegistro = async (key, payload = {}) => updateControleDescargaRegistroAtivo(key, false, payload);
export const criarDescargaManual = async (payload) => {
    const response = await post(DESCARGA_CONTROLE_MANUAL_URL, payload, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    return response?.data || response;
};
export const atualizarDescargaManual = async (id, payload) => {
    const response = await put(`${DESCARGA_CONTROLE_MANUAL_URL}/${encodeURIComponent(String(id))}`, payload, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    return response?.data || response;
};
export const excluirDescargaManual = async (id) => {
    const response = await deleteRequest(`${DESCARGA_CONTROLE_MANUAL_URL}/${encodeURIComponent(String(id))}`, {
        headers: {
            Accept: 'application/json'
        }
    });
    return response?.data || response;
};
export const getControleDescargaAuditorias = async (filters = {}) => {
    const query = buildQueryString(filters);
    const url = query ? `${DESCARGA_CONTROLE_AUDITORIAS_URL}?${query}` : DESCARGA_CONTROLE_AUDITORIAS_URL;
    const response = await get(url, {
        headers: {
            Accept: 'application/json'
        }
    });
    return response?.data || response || {};
};
const getControleDescargaRelatorio = async (urlBase, filters = {}) => {
    const query = buildQueryString(filters);
    const url = query ? `${urlBase}?${query}` : urlBase;
    const response = await get(url, {
        responseType: 'blob',
        headers: {
            Accept: 'application/octet-stream'
        }
    });
    return response?.data || response;
};
export const getControleDescargaRelatorioExcel = async (filters = {}) => getControleDescargaRelatorio(DESCARGA_CONTROLE_RELATORIO_EXCEL_URL, filters);
export const getControleDescargaRelatorioPdf = async (filters = {}) => getControleDescargaRelatorio(DESCARGA_CONTROLE_RELATORIO_PDF_URL, filters);
const getControleDescargaMetrica = async (path, filters = {}) => {
    const query = buildQueryString(filters);
    const urlBase = `${DESCARGA_CONTROLE_METRICAS_URL}/${path}`;
    const url = query ? `${urlBase}?${query}` : urlBase;
    const response = await get(url, {
        headers: {
            Accept: 'application/json'
        }
    });
    return response?.data || response || {};
};
export const getControleDescargaTempoEsperaMedio = async (filters = {}) => getControleDescargaMetrica('tempo-espera-medio', filters);
export const getControleDescargaAtrasosDescarga = async (filters = {}) => getControleDescargaMetrica('atrasos-descarga', filters);
export const getControleDescargaLojasComMaisAtrasos = async (filters = {}) => getControleDescargaMetrica('lojas-com-mais-atrasos', filters);
export const getControleDescargaRankingMediaTempoLoja = async (filters = {}) => getControleDescargaMetrica('ranking-media-tempo-loja', filters);
export const getControleDescargaMediaTempoLoja = async (filters = {}) => getControleDescargaMetrica('media-tempo-loja', filters);
export const getControleDescargaTodasCargasUltimosDias = async (filters = {}) => getControleDescargaMetrica('todas-cargas-ultimos-dias', filters);
export const getControleDescargaChegadasForaJanela = async (filters = {}) => getControleDescargaMetrica('chegadas-fora-janela', filters);
export const getControleDescargaLojasForaJanela = async (filters = {}) => getControleDescargaMetrica('lojas-fora-janela', filters);
const withQuery = (urlBase, params = {}) => {
    const query = buildQueryString(params);
    return query ? `${urlBase}?${query}` : urlBase;
};
const JANELA_JSON_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
export const getJanelasDescarga = async (params) => {
    const response = await get(withQuery(JANELAS_URL, params), {
        headers: { Accept: 'application/json' }
    });
    return response?.data || response;
};
export const getJanelaDescarga = async (id) => {
    const response = await get(`${JANELAS_URL}/${encodeURIComponent(String(id))}`, {
        headers: { Accept: 'application/json' }
    });
    return response?.data || response;
};
export const getJanelaDescargaDestino = async (params) => {
    const response = await get(withQuery(`${JANELAS_URL}/destino`, params), {
        skipNotification: true,
        headers: {
            Accept: 'application/json',
            'X-Skip-Notification': 'true'
        }
    });
    return response?.data || response;
};
export const criarJanelaDescarga = async (payload) => {
    const response = await post(JANELAS_URL, payload, { headers: JANELA_JSON_HEADERS });
    return response?.data || response;
};
export const atualizarJanelaDescarga = async (id, payload) => {
    const response = await put(`${JANELAS_URL}/${encodeURIComponent(String(id))}`, payload, {
        headers: JANELA_JSON_HEADERS
    });
    return response?.data || response;
};
export const excluirJanelaDescarga = async (id) => {
    const response = await deleteRequest(`${JANELAS_URL}/${encodeURIComponent(String(id))}`, undefined, { headers: { Accept: 'application/json' } });
    return response?.data || response;
};
export const getJanelaDescargaAuditorias = async (id, params) => {
    const response = await get(withQuery(`${JANELAS_URL}/${encodeURIComponent(String(id))}/auditorias`, params), { headers: { Accept: 'application/json' } });
    return response?.data || response;
};
export const getJanelasDescargaAuditoriasGeral = async (params) => {
    const response = await get(withQuery(`${JANELAS_URL}/auditorias`, params), {
        headers: { Accept: 'application/json' }
    });
    return response?.data || response;
};
